import React from 'react';
import { Box, Typography } from '@mui/material';

interface AppEmptyStateProps {
  message?: string;
  icon?: React.ReactNode;
  minHeight?: number | string;
}

export default function AppEmptyState({
  message = 'No records found',
  icon,
  minHeight = 80,
}: AppEmptyStateProps) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        minHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1,
        py: 2,
      }}
    >
      {icon ? <Box>{icon}</Box> : null}
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
}
